import clsx from "clsx";
import ButtonLayout from "../ButtonLayout";

export default function BlueButton(
    {
        children,
        className,
        icon = null
    }
){
    return (
        <ButtonLayout
        className={clsx(
            "bg-zoeil-blue text-white",
            className
        )}
        icon={icon}>
            {children}
        </ButtonLayout>
    )
}